import { getBreakpoint } from 'Utils/breakpoints.js';

$(window).on('load', function() {
    const imageSliders = $('.image-slider');
    if (imageSliders.length) {
        imageSliders.each(function(_,v) {
            const element = $(v);
            const bID = element.attr('id');
            const sliderContainer = $('.image-slider__' + bID);
            const slider = sliderContainer.find('.image-slider__slideshow');
            var settings = {
                arrows: true,
                dots: false,
                rows: 0,
                slidesToScroll: 1,
                slidesToShow: 1,
                slide: '.image-slider__slide',
                prevArrow: '<span class="slick-arrow slick-arrow__prev"></span>',
                nextArrow: '<span class="slick-arrow slick-arrow__next"></span>',
                responsive: [
                    {
                        breakpoint: getBreakpoint('lg'),
                        settings: {
                            arrows: false,
                            dots: true
                        }
                    }
                ]
            };

            if (sliderContainer.hasClass('two-up')) {
                console.log('two-up');
                settings = {
                    arrows: true,
                    dots: false,
                    rows: 0,
                    slidesToScroll: 2,
                    slidesToShow: 2,
                    slide: '.image-slider__slide',
                    prevArrow: '<span class="slick-arrow slick-arrow__prev"></span>',
                    nextArrow: '<span class="slick-arrow slick-arrow__next"></span>',
                    responsive: [
                        {
                            breakpoint: getBreakpoint('lg'),
                            settings: {
                                arrows: false,
                                dots: true,
                                slidesToScroll: 1,
                                slidesToShow: 1
                            }
                        }
                    ]
                };
            } else if (sliderContainer.hasClass('three-up')) {
                console.log('three-up');
                settings = {
                    arrows: true,
                    dots: false,
                    rows: 0,
                    slidesToScroll: 3,
                    slidesToShow: 3,
                    slide: '.image-slider__slide',
                    prevArrow: '<span class="slick-arrow slick-arrow__prev"></span>',
                    nextArrow: '<span class="slick-arrow slick-arrow__next"></span>',
                    responsive: [
                        {
                            breakpoint: getBreakpoint('lg'),
                            settings: {
                                arrows: false,
                                dots: true,
                                slidesToScroll: 1,
                                slidesToShow: 1
                            }
                        }
                    ]
                };
            }
            console.log(settings);

            slider.slick(settings);
        });
    }
})
